import React, {useState} from 'react';
import { AiOutlinePlus } from "react-icons/ai"; 
import { BiTrash } from "react-icons/bi"; 
import { BiEditAlt } from "react-icons/bi"; 
import '../css/MembersTable.css';
import PartnersForm from '../forms/PartnersForm';
import EditPartnerForm from '../forms/edits/EditPartnerForm';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { partners } from './../Data/partners';

function PartnersTable() {
    const [searchTerm, setSearchTerm] = useState("");
          const [currentPage, setCurrentPage] = useState(1);
          const [itemsPerPage, setItemsPerPage] = useState(5);
          const [showModal, setShowModal] = useState(false);
          const [showEditModal, setShowEditModal] = useState(false);
          const [selectedPartner, setSelectedPartner] = useState({});
        
        
          const filteredData = partners.filter((partner) => {
            return partner.name.toLowerCase().includes(searchTerm.toLowerCase());
          });
        
          const indexOfLastItem = currentPage * itemsPerPage;
          const indexOfFirstItem = indexOfLastItem - itemsPerPage;
          const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
        
          const paginate = (pageNumber) => setCurrentPage(pageNumber);
        
          const handleAddNew = () => {
            setShowModal(true);
          };
        
          const handleCloseModal = () => {
            setShowModal(false);
          };
        
          const handleEditPartner = (partner) => {
            setSelectedPartner(partner);
            setShowEditModal(true);
          };
        
          const handleCloseEditModal = () => {
            setShowEditModal(false);
          };
        
          const handleUpdatePartner = (updatedPartner) => {
            const updatedList = partners.map((partner) => {
              if (partner.name === selectedPartner.partner) {
                return updatedPartner;
              }
              return partner;
            });
        
            setShowEditModal(false);
          };
        
          const handleDeletePartner = (partner) => {
            if (window.confirm(`Voulez-vous vraiment supprimer le partenaire ${partner.name} ?`)) {
              
              toast.success(`le partenaire  ${partner.name} a été supprimé avec succès !`);
            }
          };
  return (
    <div className="container mx-auto p-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg okh3 font-bold">Partenaires et services</h3>
        <div className="flex gap-2">
          <button className="btn-primary" onClick={handleAddNew}><AiOutlinePlus /> Ajouter un partenaire</button>
          <button className="btn-secondary">Export partenaire (Excel)</button>
          <input
            type="text"
            placeholder="Rechercher un partenaire..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-bar"
          />
        </div>
      </div>

      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 px-4 py-2">Nom</th>
            <th className="border border-gray-300 px-4 py-2">Service</th>
            <th className="border border-gray-300 px-4 py-2">Operation</th>
          </tr>
        </thead>
        <tbody>
        {currentItems.map((partner, index) => (
            <tr key={index} className="text-center">
              <td className="border border-gray-300 px-4 py-2">{partner.name}</td>
              <td className="border border-gray-300 px-4 py-2">{partner.serviceId.name}</td>
              <td className="border border-gray-300 px-4 py-2">
                <button className="text-blue-500 mx-1" onClick={() =>  handleEditPartner(partner)}><BiEditAlt /></button>
                <button className="text-red-500 mx-1" onClick={() => handleDeletePartner(partner)}><BiTrash /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pagination">
        {Array.from(
          { length: Math.ceil(filteredData.length / itemsPerPage) },
          (_, i) => (
            <button
              key={i + 1}
              onClick={() => paginate(i + 1)}
              className={currentPage === i + 1 ? "active" : ""}
            >
              {i + 1}
            </button>
          )
        )}
      </div>

        {showModal && (
            <div className="modal">
            <div className="modal-content">
                <button className="close-button" onClick={handleCloseModal}>
                &times;
                </button>
                <PartnersForm />
            </div>
            </div>
        )}


        {showEditModal && (
            <div className="modal">
            <div className="modal-content">
                <button className="close-button" onClick={handleCloseEditModal}>
                &times;
                </button>
                <EditPartnerForm partner={selectedPartner} handleUpdatePartner={handleUpdatePartner}/>
            </div>
            </div>
        )}
    </div>
  )
}

export default PartnersTable